import { createAppSlice } from "@/store/utils";

export const acceptTermsSlice = createAppSlice({
  name: "acceptTerms",
  initialState: {
    accepted: false
  },
  reducers: (creator) => ({
    toogleTerms: creator.reducer<boolean | undefined>((state, { payload }) => {
      Object.assign(state, { accepted: payload || !state.accepted });
    })
  })
});

export const acceptTermsActions = acceptTermsSlice.actions;
